import { UserData } from '@root/hooks/useUserData';
import style from '@root/scss/credit7/index.module.scss';
import { useTranslation } from 'react-i18next';

type CardInfoK7Props = {
  userData: UserData | null;
};

export const CardInfo = (props: CardInfoK7Props) => {
  const { userData } = props;
  const { t } = useTranslation(['common']);

  if (userData) {
    const {
      options: { agreementId },
      payAmount
    } = userData;
    return (
      <>
        <div
          className={`${style.blockForm__top} ${style['blockForm__top--xs-mb']}`}
        >
          <p>
            {`${t('common:pay_credit_order')}`}
            <br />
            {` №${agreementId}`}
          </p>
          <p className={style.price}>{payAmount} &#8376;</p>
        </div>
        {/* <div className={`${style.blockForm__top} `}>
          <p>{t('common:pay_credit_fee')}</p>
          <p>{fee} &#8376;</p>
        </div> */}
      </>
    );
  }

  return null;
};
